// extracted by mini-css-extract-plugin
export const wrapper = "LandscapePlans-module--wrapper--1--5-";
export const graphic = "LandscapePlans-module--graphic--3WNtD";
export const graphicWrapper = "LandscapePlans-module--graphicWrapper--1H6_H";